import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Camera } from 'lucide-react';
import './Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50;
      setScrolled(isScrolled);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  const handleNavClick = () => {
    closeMenu();
    // Scroll to top when navigating to any page
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <Link to="/" className="navbar-brand" onClick={handleNavClick}>
          <Camera className="logo-icon" />
          <span className="brand-text">Vellichor Visions</span>
        </Link>

        <div className={`navbar-menu ${isOpen ? 'active' : ''}`}>
          <Link 
            to="/" 
            className={`nav-link ${isActive('/') ? 'active' : ''}`}
            onClick={handleNavClick}
          >
            Home
          </Link>
          <Link 
            to="/portraits" 
            className={`nav-link ${isActive('/portraits') ? 'active' : ''}`}
            onClick={handleNavClick}
          >
            Portraits
          </Link>
          <Link 
            to="/headshots" 
            className={`nav-link ${isActive('/headshots') ? 'active' : ''}`}
            onClick={handleNavClick}
          >
            Headshots
          </Link>
          <Link 
            to="/real-estate" 
            className={`nav-link ${isActive('/real-estate') ? 'active' : ''}`}
            onClick={handleNavClick}
          >
            Real Estate
          </Link>
          {/* Blog link deactivated */}
          {/* <Link 
            to="/blog" 
            className={`nav-link ${isActive('/blog') ? 'active' : ''}`}
            onClick={closeMenu}
          >
            Blog
          </Link> */}
          <Link 
            to="/booking" 
            className="nav-link btn btn-primary"
            onClick={() => {
              closeMenu();
              // Scroll to top when navigating to booking page
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
          >
            Book Now
          </Link>
        </div>

        <button className="navbar-toggle" onClick={toggleMenu}>
          {isOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
    </nav>
  );
};

export default Navbar; 